export type FloorplanAssetObjectType = 'table' | 'booth' | 'decor' | 'fixture'
export type PreviewCameraPreset =
  | 'top'
  | 'isoFront'
  | 'isoBack'
  | 'isoLeft'
  | 'isoRight'
export type AssetRotationBehavior = 'symmetric' | 'directional'
export type DirectionalSprites = Partial<Record<PreviewCameraPreset, string>>
export type AssetRenderMeta = {
  footprintWidthCm: number
  footprintDepthCm: number
  spriteWidthCm: number
  spriteHeightCm: number
  anchorX: number
  anchorY: number
  spriteOffsetX?: number
  spriteOffsetY?: number
}

export type FloorplanAssetDefinition = {
  id: string
  name: string
  objectType: FloorplanAssetObjectType
  editorSvgUrl: string
  previewSvgUrl: string
  nativeWidthCm: number
  nativeDepthCm: number
  anchor?: 'center'
  previewSpriteOffsetXCm?: number
  previewSpriteOffsetYCm?: number
  previewShadowScaleX?: number
  previewShadowScaleY?: number
  rotationBehavior: AssetRotationBehavior
  directionalSprites?: DirectionalSprites
  renderMeta: AssetRenderMeta
}

export const FLOORPLAN_ASSETS: Record<string, FloorplanAssetDefinition> = {
  round_table_default: {
    id: 'round_table_default',
    name: 'Round Table',
    objectType: 'table',
    editorSvgUrl: '/floorplan-assets/tables/round-table.svg',
    previewSvgUrl: '/floorplan-assets/tables/round-table.svg',
    nativeWidthCm: 120,
    nativeDepthCm: 120,
    anchor: 'center',
    previewSpriteOffsetXCm: 0,
    previewSpriteOffsetYCm: -6,
    previewShadowScaleX: 0.92,
    previewShadowScaleY: 0.28,
    rotationBehavior: 'symmetric',
    renderMeta: {
      footprintWidthCm: 120,
      footprintDepthCm: 120,
      spriteWidthCm: 120,
      spriteHeightCm: 120,
      anchorX: 0.5,
      anchorY: 0.84,
      spriteOffsetX: 0,
      spriteOffsetY: -6,
    },
  },
  booth_default: {
    id: 'booth_default',
    name: 'Booth',
    objectType: 'booth',
    editorSvgUrl: '/floorplan-assets/booths/booth.svg',
    previewSvgUrl: '/floorplan-assets/booths/booth.svg',
    nativeWidthCm: 240,
    nativeDepthCm: 120,
    anchor: 'center',
    previewSpriteOffsetXCm: 0,
    previewSpriteOffsetYCm: -10,
    previewShadowScaleX: 0.9,
    previewShadowScaleY: 0.24,
    rotationBehavior: 'directional',
    directionalSprites: {
      isoFront: '/floorplan-assets/booths/booth.svg',
      isoBack: '/floorplan-assets/booths/booth.svg',
      isoLeft: '/floorplan-assets/booths/booth.svg',
      isoRight: '/floorplan-assets/booths/booth.svg',
      top: '/floorplan-assets/booths/booth.svg',
    },
    renderMeta: {
      footprintWidthCm: 240,
      footprintDepthCm: 120,
      spriteWidthCm: 240,
      spriteHeightCm: 120,
      anchorX: 0.5,
      anchorY: 0.9,
      spriteOffsetX: 0,
      spriteOffsetY: -10,
    },
  },
}

export function getFloorplanAssetDefinitionById(
  assetId: string | null | undefined
): FloorplanAssetDefinition | null {
  const normalized = assetId?.trim()
  if (!normalized) return null
  return FLOORPLAN_ASSETS[normalized] ?? null
}
